import { applyFilters, doRequest } from "./helpers";

// One service for the provider-agnostic CRM lead, scoped to its owner. The
// backend mounts the lead routes under `/campaign/<id>/leads`, so `scope`
// ("campaign") plus the owner id select the path.
export default class LeadService {
  static async getLeads(scope, id, filters = null) {
    let path = `/${scope}/${id}/leads/`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async updateStatus(scope, id, leadId, statusId) {
    return doRequest("PUT", `/${scope}/${id}/leads/${leadId}`, {
      data: { status_id: statusId },
    });
  }

  static async deleteLead(scope, id, leadId) {
    return doRequest("DELETE", `/${scope}/${id}/leads/${leadId}`);
  }

  static async bulkUpdateStatus(scope, id, leadIds, statusId) {
    return doRequest("PUT", `/${scope}/${id}/leads/status`, {
      data: { lead_ids: leadIds, status_id: statusId },
    });
  }

  static async getSwoogoRegistrantLeads(registrantIds) {
    const path = applyFilters(
      { registrant_ids: registrantIds.join(",") },
      "/lead/swoogo_registrants"
    );
    return doRequest("GET", path);
  }

  static async setSwoogoRegistrantLeadStatus(registrantIds, statusId) {
    return doRequest("PUT", "/lead/swoogo_registrants/status", {
      data: { registrant_ids: registrantIds, status_id: statusId },
    });
  }
}
